<div class="row">
  @if (labelText) {
<div [ngClass]="{'col-md-4': !bigInput && !modal, 'col-md-2': bigInput && !modal,
                    'col-modal-4': !bigInput && modal, 'col-modal-2': bigInput && modal}">
      <label (click)="onClickLinkLabel()" [ngClass]="{'linkItemLabel': clickableLabel}">@if (mandatory) {
        <span style="color: red">*</span>
      }{{labelText + endingCharacter()}}</label>
    </div>
  }
  <div [ngClass]="{ 'col-md-12': !labelText,
                    'col-md-8': labelText && (!bigInput && !modal),
                    'col-md-10': labelText && (bigInput && !modal),
                    'col-modal-8': labelText && (!bigInput && modal),
                    'col-modal-10': labelText && (bigInput && modal)}">
    @if (((fieldLevelSecurity === 'U' || fieldLevelSecurity === 'A') && editable) || (fieldLevelSecurity === undefined && editable)) {
      <mat-form-field
      [ngClass]="{'fullWidth': !isButtonDisplayed,
                                'alignRight': decimal || right,
                                'inputErrorBackground': validatorMessages.length > 0,
                                'linkItem': link,
                                'postFixingInput': postfixLabel !== undefined,
                                'textBold': bold === true,
                                'tableInput': tableInput}">
        <input matInput
          [ngModel]="decimal && (value !== undefined && value !== null) && (!editable || pipe) ? (value | toNumber): value"
          (ngModelChange)="value=$event" [ngStyle]="{'width': + inputWidth + 'px'}"
          [ngClass]="{'linkItem': link}"
          [disabled]="!editable" (blur)="offFocus(); tooltip.hide(); pipe=true;" [matTooltip]="toolTips"
          (focus)="tooltip.show(); pipe=false;" #tooltip="matTooltip"
          [required]="mandatory" [maxLength]="maxLength" [minLength]="minLength" [type]="type"
          (click)="onClickLink()">
          @if (postfixLabel !== undefined) {
            <div class="postfixLabel">
              {{postfixLabel}}
            </div>
          }
        </mat-form-field>
      }
      @if ((!editable && (fieldLevelSecurity === 'U' || fieldLevelSecurity === 'A')) || (fieldLevelSecurity === undefined && !editable) || fieldLevelSecurity === 'I') {
        <mat-form-field (click)="onClickLink()"
                    [ngClass]="{'fullWidth': !isButtonDisplayed,
                     'alignRight': decimal || right,
                     'postFixingInput': postfixLabel !== undefined,
                     'textBold': bold === true,
                     'tableInput': tableInput}">
          <input matInput
            [ngModel]="decimal && (value !== undefined && value !== null) ? (value | toNumber): value"
            [ngStyle]="{'width': + inputWidth + 'px'}"
            [ngClass]="{'linkItem': link, 'postFixingInput': postfixLabel !== undefined, 'textBold': bold === true}"
            [disabled]="true" (blur)="offFocus(); tooltip.hide()" [matTooltip]="toolTips" (focus)="tooltip.show()"
            #tooltip="matTooltip"
            [required]="mandatory" [maxLength]="maxLength" [minLength]="minLength" [type]="type">
            @if (postfixLabel !== undefined) {
              <div class="postfixLabel">
                {{postfixLabel}}
              </div>
            }
          </mat-form-field>
        }
        @if (fieldLevelSecurity === 'N') {
          <mat-form-field
                    [ngClass]="{'fullWidth': true,
                     'alignRight': decimal || right,
                     'tableInput': tableInput}">
            <input matInput
              [ngStyle]="{'width': + inputWidth + 'px'}"
              [disabled]="true" [type]="type">
            </mat-form-field>
          }
          @if (fieldLevelSecurity !== 'I' && fieldLevelSecurity !== 'N' && isButtonDisplayed && !excel) {
            <i class="fa fa-search" (click)="onClick($event)"></i>
          }
          @if (fieldLevelSecurity !== 'I' && fieldLevelSecurity !== 'N' && isButtonDisplayed && editable && excel) {
            <i class="fa fa-download" (click)="onClick($event)" title="Download to Excel"></i>
          }
          @for (message of validatorMessages; track message) {
            <div class="inputValidationMessage" [ngClass]="{'inputValidationMessageTable' : tableInput}">
              {{message}}
            </div>
          }
        </div>
      </div>

